import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';

const socket = io('https://api.surajrestaurant.in'); // ✅ Change this to your server URL

const CancelReport = () => {
    const today = new Date().toISOString().split('T')[0];

    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);

    const [reportData, setReportData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mobileFilter, setMobileFilter] = useState('');
    const [nameFilter, setNameFilter] = useState('');

    const fetchReport = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `https://api.surajrestaurant.in/102/cancel/report?startDate=${startDate}&endDate=${endDate}`
            );
            const data = await response.json();
            if (data.success) {
                setReportData(data.report);
                setFilteredData(data.report);
            }
        } catch (error) {
            console.error('Error fetching cancel report:', error);
        } finally {
            setLoading(false);
        }
    };

    // 🔁 Fetch report on mount and when date changes
    useEffect(() => {
        fetchReport();
    }, [startDate, endDate]);

    // 🔌 Socket listener for new cancelled order
    useEffect(() => {
        socket.on('cancelOrderUpdated', (newOrder) => {
            const orderDate = new Date(newOrder.createdAt).toISOString().split('T')[0];
            if (orderDate >= startDate && orderDate <= endDate) {
                setReportData((prev) => [newOrder, ...prev]);
                setFilteredData((prev) => [newOrder, ...prev]);
            }
        });

        return () => {
            socket.off('cancelOrderUpdated'); // 🧼 Clean up on unmount
        };
    }, [startDate, endDate]);

    // 🔍 Filter logic for name and mobile
    useEffect(() => {
        const filtered = reportData.filter((item) => {
            const nameMatch = item.name.toLowerCase().includes(nameFilter.toLowerCase());
            const mobileMatch = item.mobileNumber.toString().includes(mobileFilter);
            return nameMatch && mobileMatch;
        });
        setFilteredData(filtered);
    }, [nameFilter, mobileFilter, reportData]);

    return (
        <div className="p-6 bg-blue-200 min-h-screen">
            <h1 className="text-center text-xl font-bold text-white bg-yellow-800 py-2 rounded-t-md px-6">
                Cancel Report
            </h1>

            <div className="flex flex-col sm:flex-row gap-4 mb-4 justify-end">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Customer Name</label>
                    <input
                        type="text"
                        placeholder="Filter by name"
                        className="border rounded-lg p-2 w-1/2 sm:w-64"
                        value={nameFilter}
                        onChange={(e) => setNameFilter(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Mobile No</label>
                    <input
                        type="text"
                        placeholder="Filter by mobile number"
                        className="border rounded-lg p-2 w-1/2 sm:w-64"
                        value={mobileFilter}
                        onChange={(e) => setMobileFilter(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">From Date:</label>
                    <input
                        type="date"
                        value={startDate}
                        max={endDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="border rounded-lg p-2 w-full sm:w-48"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">To Date:</label>
                    <input
                        type="date"
                        value={endDate}
                        min={startDate}
                        max={today}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="border rounded-lg p-2 w-full sm:w-48"
                    />
                </div>
            </div>

            {/* Table */}
            {loading ? (
                <p className="text-center text-gray-600">Loading...</p>
            ) : (
                <div className="max-h-[400px] overflow-y-auto">
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="p-3 border-b">#</th>
                                <th className="p-3 border-b">Name</th>
                                <th className="p-3 border-b">Order ID</th>
                                <th className="p-3 border-b">Mobile Number</th>
                                <th className="p-3 border-b">Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="p-4 text-center text-gray-500">
                                        No matching cancellations found.
                                    </td>
                                </tr>
                            ) : (
                                filteredData.map((item, index) => (
                                    <tr key={item.orderId || index} className="hover:bg-gray-50">
                                        <td className="p-3 border-b">{index + 1}</td>
                                        <td className="p-3 border-b">{item.name}</td>
                                        <td className="p-3 border-b">{item.orderId}</td>
                                        <td className="p-3 border-b">{item.mobileNumber}</td>
                                        <td className="p-3 border-b">{item.address}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default CancelReport;
